import { Button, Card, Center, Group, Stack, Text, Title } from '@mantine/core';
import { IconPlaneOff } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useSession } from '../../app/session';
import { LanguageSwitcher } from '../../components/LanguageSwitcher';

/**
 * Shown to a signed-in user who belongs to no organisation.
 *
 * Every screen below `/$org` needs a club to scope its data to, so there is nothing useful to
 * render until an administrator grants membership.
 */
export function NoAccessPage() {
  const { t } = useTranslation();
  const { user, signOut } = useSession();

  return (
    <Center mih="100vh" p="md">
      <Card p="xl" radius="md" w={460} withBorder>
        <Stack gap="md" align="center">
          <IconPlaneOff size={44} opacity={0.4} />
          <Title order={3} ta="center">
            {t('app.name')}
          </Title>
          <Text ta="center" c="dimmed" fz="sm">
            {t('auth.noOrganisation')}
          </Text>
          {user?.email ? (
            <Text fz="xs" c="dimmed">
              {user.email}
            </Text>
          ) : null}
          <Group gap="sm">
            <LanguageSwitcher />
            <Button variant="light" onClick={() => void signOut()}>
              {t('action.signOut')}
            </Button>
          </Group>
        </Stack>
      </Card>
    </Center>
  );
}
